import React, { useEffect } from 'react';
import { Navigate, useLocation, matchPath } from 'react-router-dom';
import { useAuth } from '../../Context/Auth/AuthContext';
import routes from '../../Routes/Routes';

const ProtectedRoute = ({ children }) => {
  const { auth } = useAuth();
  const location = useLocation();
  const token = sessionStorage.getItem('authToken');

  const currentRoute = routes.find((route) =>
    matchPath({ path: route.path, end: true }, location.pathname)
  );

  const allowedRoles = currentRoute?.roles || [];
  const userRoleId = auth.role?._id || auth.user?.role?._id;

  useEffect(() => {
    console.log('Allowed Roles:', allowedRoles);
    console.log('User Role ID:', userRoleId);
  }, [allowedRoles, userRoleId]);

  if (!token) {
    return <Navigate to="/" replace />;
  }

  // ✅ Wait until role is ready
  if (allowedRoles.length > 0 && !userRoleId) {
    return null; // or show a loader
  }

  // 🔐 Check access
  if (allowedRoles.length > 0 && !allowedRoles.includes(userRoleId)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
